<div
  class="name-avatar"
  [ngClass]="size === 'large' ? 'name-avatar-lg' : 'name-avatar-sm'"
>
  <p class="font-inter" [ngClass]="size === 'large' ? 'lg' : 'sm'">
    {{ getInitials(name) || '--' }}
  </p>
</div>
